export const contColumns = [
  {
    prop: "brandIdStr",
    label: "品牌",
  },
  {
    prop: "carModelIdStr",
    label: "车型",
  },
  {
    prop: "mainOrderNo",
    label: "主机订单号",
    width: "145px",
  },
  {
    prop: "upstreamOrderNo",
    label: "上游订单号",
  },
  {
    prop: "customerName",
    label: "客户名称",
  },
  {
    prop: "contactInfo",
    label: "联系方式",
  },
  {
    prop: "vin",
    label: "车架号",
    width: "140px",
  },
  {
    prop: "installerIdStr",
    label: "安装师傅",
  },
    {
    prop: "lineLength",
    label: "用线长度",
  },
    {
    prop: "addOutlay",
    label: "增项费用",
  },
  {
    prop: "installFee",
    label: "安装费用",
  },
  // {
  //   prop: "remarks",
  //   label: "备注",
  //   showOverflowTooltip: true,
  // },
  // {
  //   prop: "source",
  //   label: "来源",
  // },
  {
    prop: "createTime",
    label: "创建时间",
    width: "135px",
  },
  {
    prop: "createdByStr",
    label: "创建人",
  },
  {
    prop: "updateTime",
    label: "修改时间",
    width: "135px",
  },
  {
    prop: "updatedByStr",
    label: "修改人",
  },
];

export const straightColumns = [
  {
    prop: "incentiveName",
    label: "名称",
  },
  {
    prop: "incentiveType",
    label: "激励类型",
    slot: "incentiveType",
  },
  {
    prop: "incentiveRemarks",
    label: "正/负激励备注",
    showOverflowTooltip: true,
  },
  {
    prop: "incentiveAttachmentIds",
    label: "正/负激励附件",
    slot: "incentiveAttachmentIds",
  },
  {
    prop: "remarks",
    label: "备注",
    showOverflowTooltip: true,
  },
  {
    prop: "amount",
    label: "金额",
  },
  {
    prop: "attachmentIds",
    label: "附件",
    slot: "attachmentIds",
  },
  {
    prop: "relatedOrderIds",
    label: "关联订单",
    slot: "relatedOrderIds",
  },
  {
    prop: "responsibleUserIdStr",
    label: "对应师傅",
  },
];
export const manageColumns = [
    {
    prop: "brandIdStr",
    label: "品牌",
  },
  {
    prop: "carModelIdStr",
    label: "车型",
  },
  {
    prop: "mainOrderNo",
    label: "主机订单号",
    width: "145px",
  },
  {
    prop: "upstreamOrderNo",
    label: "上游订单号",
  },
  {
    prop: "customerName",
    label: "客户名称",
  },
  {
    prop: "contactInfo",
    label: "联系方式",
  },
  {
    prop: "vin",
    label: "车架号",
    width: "140px",
  },
  {
    prop: "installerIdStr",
    label: "安装师傅",
  },
  // {
  //   prop: "mainOrderNo",
  //   label: "主机订单号",
  // },
  // {
  //   prop: "upstreamOrderNo",
  //   label: "上游订单号",
  // },
  // {
  //   prop: "installerIdStr",
  //   label: "安装师傅",
  // },
  {
    prop: "manageFee",
    label: "管理费用",
  },
  {
    prop: "feeGroupIdStr",
    label: "所属管理群组",
  },
];
export const otherColumns = [
  {
    prop: "name",
    label: "名称",
    showOverflowTooltip: true,
  },
  {
    prop: "incentiveType",
    label: "正/负",
    slot: "incentiveType",
  },
  {
    prop: "amount",
    label: "金额",
  },
  {
    prop: "remark",
    label: "备注",
    showOverflowTooltip: true,
  },
  {
    prop: "attachmentIds",
    label: "附件",
    slot: "attachmentIds",
  },
  {
    prop: "responsibleUserIdStr",
    label: "对应师傅",
  },
];
export const commissionColumns = [
  {
    prop: "addOutlay",
    label: "增项金额",
    width: "120px",
    slot: "addOutlay",
  },
  {
    prop: "commissionAmount",
    label: "提成金额",
    width: "120px",
    slot: "commissionAmount",
  },
  {
    prop: "commissionRate",
    label: "提成比例",
    width: "100px",
    slot: "commissionRate",
  },
  {
    prop: "commissionUserName",
    label: "提成人",
    width: "120px",
    showOverflowTooltip: true,
  },
  {
    prop: "installerName",
    label: "安装师傅",
    width: "120px",
    showOverflowTooltip: true,
  },
  {
    prop: "commissionRemarks",
    label: "提成备注",
    showOverflowTooltip: true,
  },
  {
    prop: "companyName",
    label: "所属公司",
    showOverflowTooltip: true,
  },
  {
    prop: "brandName",
    label: "品牌",
    showOverflowTooltip: true,
  },
  {
    prop: "modelName",
    label: "车型",
    showOverflowTooltip: true,
  },
  {
    prop: "mainOrderNo",
    label: "主机订单号",
    width: "145px",
    showOverflowTooltip: true,
  },
  {
    prop: "upstreamOrderNo",
    label: "上游订单号",
    showOverflowTooltip: true,
  },
  {
    prop: "customerName",
    label: "客户名称",
    showOverflowTooltip: true,
  },
  {
    prop: "contactInfo",
    label: "联系方式",
    showOverflowTooltip: true,
  },
  {
    prop: "vin",
    label: "车架号",
    width: "140px",
    showOverflowTooltip: true,
  },
];

// 被提成表格列定义（在提成比例后增加提成人和安装师傅列）
export const installerCommissionColumns = [
  {
    prop: "addOutlay",
    label: "增项金额",
    width: "120px",
    slot: "addOutlay",
  },
  {
    prop: "commissionAmount",
    label: "提成金额",
    width: "120px",
    slot: "commissionAmount",
  },
  {
    prop: "commissionRate",
    label: "提成比例",
    width: "100px",
    slot: "commissionRate",
  },
  {
    prop: "commissionUserName",
    label: "提成人",
    width: "120px",
    showOverflowTooltip: true,
  },
  {
    prop: "installerName",
    label: "安装师傅",
    width: "120px",
    showOverflowTooltip: true,
  },
  {
    prop: "commissionRemarks",
    label: "提成备注",
    showOverflowTooltip: true,
  },
  {
    prop: "companyName",
    label: "所属公司",
    showOverflowTooltip: true,
  },
  {
    prop: "brandName",
    label: "品牌",
    showOverflowTooltip: true,
  },
  {
    prop: "modelName",
    label: "车型",
    showOverflowTooltip: true,
  },
  {
    prop: "mainOrderNo",
    label: "主机订单号",
    width: "145px",
    showOverflowTooltip: true,
  },
  {
    prop: "upstreamOrderNo",
    label: "上游订单号",
    showOverflowTooltip: true,
  },
  {
    prop: "customerName",
    label: "客户名称",
    showOverflowTooltip: true,
  },
  {
    prop: "contactInfo",
    label: "联系方式",
    showOverflowTooltip: true,
  },
  {
    prop: "vin",
    label: "车架号",
    width: "140px",
    showOverflowTooltip: true,
  },
];

export const relatedOrdersColumns = [
  {
    prop: "brandIdStr",
    label: "品牌",
  },
  {
    prop: "carModelIdStr",
    label: "车型",
  },
  {
    prop: "mainOrderNo",
    label: "主机订单号",
    width: "145px",
  },
  {
    prop: "upstreamOrderNo",
    label: "上游订单号",
    width: "135px",
  },
  {
    prop: "customerName",
    label: "客户名称",
  },
  {
    prop: "contactInfo",
    label: "联系方式",
  },
  {
    prop: "vin",
    label: "车架号",
    width: "140px",
  },
  {
    prop: "installerIdStr",
    label: "安装师傅",
  },
  {
    prop: "installFee",
    label: "安装费用",
  },
  {
    prop: "remarks",
    label: "备注",
    showOverflowTooltip: true,
  },
  {
    prop: "source",
    label: "来源",
    slot: "source",
  },
  {
    prop: "createTime",
    label: "创建时间",
    width: "135px",
  },
  {
    prop: "createdByStr",
    label: "创建人",
  },
  {
    prop: "updateTime",
    label: "修改时间",
    width: "135px",
  },
  {
    prop: "updatedByStr",
    label: "修改人",
  },
];
export const materialColumns = [
  {
    prop: "materialType",
    label: "类型",
  },
  {
    prop: "model",
    label: "型号",
  },
  {
    prop: "unit",
    label: "单位",
  },
  {
    prop: "unitPrice",
    label: "单价",
  },
  {
    prop: "quantity",
    label: "数量",
  },
  {
    prop: "subtotal",
    label: "小计",
  },
  {
    prop: "remarks",
    label: "备注",
    showOverflowTooltip: true,
  },
  {
    prop: "attachmentIds",
    label: "附件",
    slot: "attachmentIds",
  },
  {
    prop: "orderTime",
    label: "订货时间",
  },
  {
    prop: "responsibleUserIdStr",
    label: "对应师傅",
  },
];

/**
 * 通用表格数据搜索过滤函数
 * @param {Array} table 表格数据
 * @param {Array} keys 搜索条件数组，如：[{key: 'name', value: 'Tom'}, {key: 'age', value: 20}]
 * @returns {Array} 过滤后的数据
 */
export const tableDataCommonSearch = (table = [], keys = []) => {
  if (!Array.isArray(keys) || keys.length === 0) return table;

  return table.filter(item => {
    return keys.every(({ key, value }) => {
      // 如果没有该字段，或者字段值为空，视为不匹配
      if (!(key in item)) return false;
      const itemValue = item[key];

      // 处理 null 或 undefined 的情况
      if (value === null || value === undefined) return true;

      // 根据类型进行比较（字符串可模糊匹配，数字等精确匹配）
      if (typeof value === 'string' && typeof itemValue === 'string') {
        return itemValue.includes(value);
      }

      return itemValue === value;
    });
  });
};

import Big from "big.js";

/**
 * 表格数据按指定字段分组并汇总指定字段总和
 * @param {Array} table 数据数组
 * @param {String} groupKey 分组字段名
 * @param {String} totalKey 求和字段名
 * @returns {Array} 分组后的结果数组
 */
export const tableDataGroupAndTotal = (table = [], groupKey = "group", totalKey = "total") => {
  const groups = {};

  // 遍历数据，按 groupKey 分组并累计 totalKey 的值
  for (const item of table) {
    const key = item[groupKey];
    const value = item[totalKey];

    if (!groups[key]) {
      groups[key] = {
        groupKey: key,
        totalPrice: new Big(0),
        children: []
      };
    }

    // 使用 Big.js 做精确加法
    groups[key].totalPrice = groups[key].totalPrice.plus(new Big(value || 0));
    groups[key].children.push(item);
  }

  // 返回分组后的数组结构
  return Object.values(groups).map(groupObj => ({
    [groupKey]: groupObj.groupKey,
    [`total${totalKey.charAt(0).toUpperCase() + totalKey.slice(1)}`]: groupObj.totalPrice.toNumber(),
    children: groupObj.children
  })).sort((a, b) =>  b.children.length - a.children.length);
};

/**
 * 多字段模糊查询
 * @param {Array} table - 表格数据（数组形式，每项是对象）
 * @param {string} content - 查询内容（用户输入的搜索关键字）
 * @param {Array} keys - 需要模糊匹配的字段名数组
 * @returns {Array} 过滤后的结果数组
 */
export const  multipleFuzzyQueries=(table, content, keys)=> {
    if (!content) return table; // 如果没有搜索内容，返回原表格
    const lowerContent = content.toLowerCase(); // 忽略大小写
    return table.filter(row =>
        keys.some(key => {
            const value = row[key];
            return value && value.toString().toLowerCase().includes(lowerContent);
        })
    );
}